import { camelCase } from 'lodash-es';

import { endpoints as autogenEnhancements } from '~/api/managed-entities/enhancements.autogen';
import { Tags } from '~/api/managed-entities/tags.autogen';

import { managedEntitiesApiRoot } from './root';

// The codegen keys its enhancements by raw operationId (e.g. `list_groups`),
// while RTK names the generated endpoints in camelCase (`listGroups`). Remap to
// the endpoint names so the schema-derived providesTags / invalidatesTags
// (from the service's x-rtk-cache) attach to the right endpoints. The generated
// endpoints are otherwise consumed 1:1 — no friendly aliases, no transforms.
const endpoints = Object.fromEntries(
  Object.entries(autogenEnhancements).map(([operationId, enhancement]) => [
    camelCase(operationId),
    enhancement,
  ]),
);

managedEntitiesApiRoot.enhanceEndpoints({ endpoints });

// Schema-derived invalidation misses the entity-type-scoped tag a poller
// needs. `enhanceEndpoints` replaces (not merges) `invalidatesTags` per
// endpoint, so every tag it should invalidate must be re-listed here, not
// just the new one.
const invalidatesAliasesAndEntityType = (
  _result: unknown,
  error: unknown,
  arg: { entityTypeId: string },
) =>
  error
    ? []
    : [
        { type: Tags.EntityAlias, id: arg.entityTypeId },
        { type: Tags.EntityType, id: 'LIST' },
        { type: Tags.EntityType, id: arg.entityTypeId },
      ];

managedEntitiesApiRoot.enhanceEndpoints({
  endpoints: {
    triggerDiscover: {
      invalidatesTags: (
        _result: unknown,
        error: unknown,
        arg: { entityTypeId: string },
      ) =>
        error
          ? []
          : [
              { type: Tags.EntityType, id: 'LIST' },
              { type: Tags.EntityType, id: arg.entityTypeId },
            ],
    },
    addAliases: { invalidatesTags: invalidatesAliasesAndEntityType },
    mergeAliases: { invalidatesTags: invalidatesAliasesAndEntityType },
  },
});
